document.addEventListener("DOMContentLoaded", function () {
    console.log("🔹 Script Loaded: Navigation & Scrolling (sessionStorage)");

    // ✅ Detect clicks on "Learn More" buttons
    document.querySelectorAll('a[href="/pages/services"]').forEach(button => {
        let serviceName = button.getAttribute("data-service");

        console.log("🔍 Found <a> Tag:", button);
        console.log("📌 Extracted data-service (if exists):", serviceName);

        if (serviceName) {
            button.addEventListener("click", function (event) {
                console.log(`🔹 Storing Service in sessionStorage: "${serviceName}"`);

                // Store selected service name in sessionStorage
                sessionStorage.setItem("selectedService", serviceName);
            });
        } else {
            console.warn("⚠️ <a> tag does not have a data-service attribute:", button);
        }
    });

    // ✅ Detect if we're on the Services Page
    if (window.location.pathname === "/pages/services") {
        console.log("✅ Detected Services Page");

        // Retrieve the stored service name from sessionStorage
        let selectedService = sessionStorage.getItem("selectedService");

        console.log("📌 Retrieved from sessionStorage:", selectedService);

        if (!selectedService) {
            console.warn("⚠️ No service found in sessionStorage.");
            return;
        }

        console.log(`🔹 Looking for service section matching: "${selectedService}"`);

        // Find the matching section by `data-service`
        let targetSection = document.querySelector(`section[data-service="${selectedService}"]`);

        if (targetSection) {
            console.log(`✅ Found Matching Section: "${selectedService}"`);
            console.log("📌 Scrolling to section:", targetSection);
            targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
            console.log("🚀 Scrolled to matched service section!");

            // Clean up sessionStorage to prevent future unwanted scrolling
            sessionStorage.removeItem("selectedService");
        } else {
            console.warn("⚠️ No matching service section found.");
            console.log("🔎 Checking all sections for debugging...");

            // Log all available service sections for manual debugging
            document.querySelectorAll("section[data-service]").forEach(section => {
                console.log("🛑 Available Section:", section.getAttribute("data-service"), section);
            });
        }
    }
});
